import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useUserId } from "@/features/auth/hooks/useUserId";
import type { DepositMethodId } from "../types";

/**
 * The method the account last deposited with, used to preselect the wizard's
 * opening screen. Availability is not guaranteed to survive between sessions,
 * so the wizard falls back to registry order when the stored method is gone.
 */
export const useLastUsedDepositMethod = () => {
  const userId = useUserId() ?? "anonymous";

  return useLocalStorage<DepositMethodId | null>(
    `lastUsedDepositMethod:${userId}`,
    null,
  );
};
